<template>
    <transition name="modal">
        <div v-if="show" class="confirm-modal-mask">
            <div class="confirm-modal-wrapper" @click="$emit('cancel')">
                <div class="confirm-modal-container" @click.stop>
                    <!-- Header -->
                    <div class="confirm-header d-flex justify-content-between align-items-center">
                        <h6 class="confirm-title mb-0">Konfirmasi Pengiriman QR</h6>
                        <button type="button" class="btn btn-close-confirm" @click="$emit('cancel')">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>

                    <!-- Body Content -->
                    <div class="confirm-body text-center">
                        <div class="confirm-icon-wrapper">
                            <svg width="108" height="98" viewBox="0 0 124 112" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M53.493 2.18918C61.9236 -2.48607 72.6478 0.58571 77.359 8.94096L122.425 87.1547C123.417 89.4893 123.851 91.3877 123.975 93.3597C124.223 97.9674 122.611 102.446 119.45 105.893C116.288 109.327 112.011 111.354 107.362 111.6H16.6092C14.6875 111.483 12.7659 111.047 10.9682 110.371C1.97967 106.747 -2.3596 96.5482 1.29778 87.7077L46.6741 8.88567C48.2239 6.11492 50.5795 3.72507 53.493 2.18918ZM61.9856 76.0902C59.0101 76.0902 56.5305 78.5476 56.5305 81.5027C56.5305 84.4454 59.0101 86.909 61.9856 86.909C64.9611 86.909 67.3786 84.4454 67.3786 81.4351C67.3786 78.4923 64.9611 76.0902 61.9856 76.0902ZM61.9856 37.7604C59.0101 37.7604 56.5305 40.1503 56.5305 43.1054V60.4855C56.5305 63.4344 59.0101 65.898 61.9856 65.898C64.9611 65.898 67.3786 63.4344 67.3786 60.4855V43.1054C67.3786 40.1503 64.9611 37.7604 61.9856 37.7604Z" fill="#F36F21"/>
                            </svg>
                        </div>

                        <div class="confirm-text">
                            <p class="mb-1">Anda akan yakin mengirim <strong>{{ qty }}</strong> QR ke</p>
                            <p class="mb-2 font-weight-bold confirm-dealer-name">{{ dealerLabel }}</p>
                            <p class="mb-0 text-muted-sub">Apa anda yakin sudah benar?</p>
                        </div>
                    </div>

                    <!-- Actions -->
                    <div class="confirm-actions d-flex justify-content-center align-items-center">
                        <button 
                            type="button" 
                            class="btn btn-confirm-batal" 
                            @click="$emit('cancel')"
                        >
                            Batal
                        </button>
                        <button 
                            type="button" 
                            class="btn btn-confirm-submit" 
                            :disabled="isSubmitting"
                            @click="$emit('confirm')"
                        >
                            <span v-if="isSubmitting">Mengirim...</span>
                            <span v-else>Ya, Kirim</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
/**
 * Confirmation dialog shown before a single QR delivery is sent,
 * used by both the create (Pengiriman Satuan) and edit flows.
 */
export default {
    name: 'ConfirmPengirimanModal',
    props: {
        show: { type: Boolean, default: false },
        qty: { type: [Number, String], default: 0 },
        dealerLabel: { type: String, default: '' },
        isSubmitting: { type: Boolean, default: false }
    }
}
</script>

<style scoped>
/* Confirmation Modal Specific Styles */
.confirm-modal-mask {
    position: fixed;
    z-index: 1060;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.3s ease;
    padding: 20px;
}

.confirm-modal-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.confirm-modal-container {
    width: 401px;
    max-width: 401px;
    height: 330px;
    background-color: #FFFFFF;
    border-radius: 8px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);
    padding: 16px 20px 20px 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;
    transform: rotate(0deg);
    opacity: 1;
}

.confirm-header {
    width: 100%;
}

.confirm-title {
    font-size: 14px;
    font-weight: 600;
    color: #111827;
}

.btn-close-confirm {
    padding: 0;
    border: none;
    background: transparent;
    color: #111827;
    font-size: 16px;
    cursor: pointer;
    line-height: 1;
}

.btn-close-confirm:hover {
    color: #6B7280;
}

.confirm-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: auto 0;
}

.confirm-icon-wrapper {
    margin-bottom: 14px;
}

.confirm-icon-wrapper svg {
    display: block;
}

.confirm-text {
    font-size: 13px;
    color: #1F2937;
    line-height: 1.4;
}

.confirm-dealer-name {
    font-size: 13px;
    color: #111827;
    word-break: break-word;
}

.text-muted-sub {
    font-size: 13px;
    color: #374151;
    margin-top: 6px;
}

.confirm-actions {
    margin-top: 8px;
}

.btn-confirm-batal {
    background: transparent;
    border: none;
    color: #F36F21;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 20px;
    margin-right: 16px;
    cursor: pointer;
    box-shadow: none;
}

.btn-confirm-batal:hover {
    color: #D95D16;
    background: transparent;
}

.btn-confirm-submit {
    background-color: #F36F21;
    border: 1px solid #F36F21;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 500;
    border-radius: 6px;
    padding: 8px 32px;
    min-width: 130px;
    box-shadow: none;
    cursor: pointer;
    transition: background-color 0.2s;
}

.btn-confirm-submit:hover:not(:disabled) {
    background-color: #D95D16;
    border-color: #D95D16;
    color: #FFFFFF;
}

.btn-confirm-submit:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .confirm-modal-container,
.modal-leave-active .confirm-modal-container {
    -webkit-transform: scale(1.05);
    transform: scale(1.05);
}
</style>
